import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VideoAds.css";

const VideoAds = () => {
  const [ad, setAd] = useState(null);

  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "https://success-blog-app-backend.onrender.com";

  const addView = async (id) => {
    try {
      // 🚀 Every load counts as a view
      await axios.post(`${BASE_URL}/api/ads/view/${id}`);
    } catch (err) {
      console.log("View update failed", err);
    }
  };

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ads/all-ads`);

        const ads = res.data.filter(
          (a) => a.adType === "video" && a.views < a.maxViews
        );

        if (!ads.length) return;

        let index = parseInt(localStorage.getItem("vidIndex")) || 0;

        if (index >= ads.length) index = 0;

        const selected = ads[index];

        localStorage.setItem("vidIndex", index + 1);

        setAd(selected);

        // every view counted (no restriction)
        addView(selected._id);
      } catch (err) {
        console.log("Error loading ads", err);
      }
    };

    fetchAds();
  }, []);

  if (!ad) return null;

  return (
    <div className="video-ad-wrapper">
      <div
        className="video-ad-box"
        onClick={() => ad.link && window.open(ad.link, "_blank")}
      >
        <video
          src={ad.image}
          controls
          autoPlay
          muted
          className="video-ad-video"
        />
      </div>
    </div>
  );
};

export default VideoAds;